export default "__VITE_ASSET__MRg0PiXw__"